export const navigation = [
  { label: "Capabilities", href: "/#capabilities" },
  { label: "Approach", href: "/how-we-work" },
  { label: "Case studies", href: "/work" },
  { label: "Firm", href: "/#firm" },
];

export const deliveryArc = ["Diagnose", "Redesign", "Build", "Embed"];

export const capabilities = [
  {
    number: "01",
    title: "Transformation planning",
    description:
      "Define the business outcome, operating constraints, investment case and delivery priorities.",
  },
  {
    number: "02",
    title: "Process and workflow design",
    description:
      "Review how work moves across teams and systems, then design a simpler operating process.",
  },
  {
    number: "03",
    title: "AI and software delivery",
    description:
      "Build and integrate software, AI and data systems within the required security and governance controls.",
  },
  {
    number: "04",
    title: "Adoption and capability building",
    description:
      "Prepare teams, establish ownership and transfer the knowledge required to operate the new system.",
  },
];

export const deliverySteps = [
  {
    number: "01",
    label: "Understand",
    title: "Define the priorities",
    description: "Confirm the business context, constraints, owners and measures of success.",
  },
  {
    number: "02",
    label: "Plan",
    title: "Set the delivery plan",
    description: "Agree the workstreams, architecture, decisions and implementation sequence.",
  },
  {
    number: "03",
    label: "Deliver",
    title: "Build and integrate",
    description: "Deliver the system with regular reviews, testing and operational integration.",
  },
  {
    number: "04",
    label: "Review",
    title: "Support adoption",
    description: "Measure the result, transfer ownership and support the operating team.",
  },
];

export const footerLinks = [
  { label: "Capabilities", href: "/#capabilities" },
  { label: "Approach", href: "/how-we-work" },
  { label: "Case studies", href: "/work" },
  { label: "Contact", href: "/contact" },
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/company/averentia/",
    external: true,
  },
];
